<template>
    <main-layout>

        <app-header icon="user">
            Profil
        </app-header>

        <action-bar :back="{name: 'home'}">
            <a class="btn add btn-full" id="main-action" href="javascript: void 0" @click="logout">
                <i class="icon-logout"></i>
                <strong>Déconnexion</strong>
            </a>
        </action-bar>

        <div class="main-content profil">

            <div class="head wrap">
                <div class="img-profil" :style="'background-image: url('+photoProfil+')'">
                </div>
                <div>
                    <h2>{{ user.first_name }}
                        <strong>{{ user.last_name }}</strong>
                    </h2>
                    <h3>Technicien</h3>
                </div>
            </div>
            <!-- head -->

            <form method="post" class="change-pdp">
                <input type="hidden" style="display: none;" name="change-photo-profil">
            </form>

            <input ref="photoInput" @change="updatePhoto" type="file" accept="image/*" id="photo-profil"
                   style="display: none;" class="hidden">
            <ul id="prev-photo-profil">
            </ul>

            <div class="photo-sign wrap">

                <a id="photo-trigger" href="javascript:void(0);" @click="triggerPhoto" class="btn btn-full">
                    <i class="icon-photo"></i>
                    <span>Photo </span>
                </a>

                <a href="javascript:void(0);" @click="showModal = true" class="btn btn-full toggle-modal">
                    <i class="icon-contract"></i>
                    <span>Signature</span>
                </a>

            </div>
            <!-- photo-sign -->

            <div class="infos-user wrap">
                <ul class="wrap">
                    <li>
                        <i class="icon-email"></i>
                        <strong>{{ user.username }}</strong>
                    </li>
                    <li>
                        <i class="icon-phone"></i>
                        <strong>{{ user.phone}}</strong>
                    </li>
                    <li v-show="user.type !== 'magasinier'">
                        <i class="icon-car"></i>
                        <strong>{{ user.immatriculation }}</strong>
                    </li>
                </ul>
                <a class="btn btn-full edit" id="edit-profil" href="javascript: void 0" @click="showFormUser = true">
                    <i class="icon-edit"></i>
                </a>
            </div>
            <!-- infos-user -->

            <section class="certificats" v-if="user.type !== 'magasinier'">
                <h3>Mon attestation d'aptitude</h3>
                <p>
                    <i class="icon-valid"></i>
                    <strong>{{ user.attestation_aptitude }}</strong>
                </p>
            </section>
            <!-- certificats -->

            <signature-modal
                v-if="showModal"
                @close="showModal = false"
                :signature="user.signature64"
                @signatureUpdated="updateSignature">
            </signature-modal>

            <div class="modal-infos" v-show="showFormUser" @closeForm="showFormUser = false">
                <div class="modal">
                    <h1>
                        <strong>Modifier </strong>mes informations
                    </h1>
                    <form method="post">
                        <cleave :options="telOpt" ref="telephone" type="text" name="numtel"
                                placeholder="Téléphone portable" v-model="user.phone" inputmode="tel"></cleave>
                        <input v-show="user.type !== 'magasinier'" type="text" name="immat" placeholder="Immatriculation vehicule"
                               v-model="user.immatriculation" maxlength="20">
                        <p class="warning-info"></p>
                        <a href="javascript: void 0" @click="saveInfos">SAUVEGARDER</a>
                        <div class="clear"></div>
                    </form>
                </div>
            </div>

            <a class="profil-lien" href="javascript: void 0"
               @click.prevent="askSendData">
                Envoyer mes données au support
            </a>

            <a class="profil-lien fixed-bottom-btn" href="javascript: void 0"
               @click.prevent="askDeleteData" v-if="isDemo === true">
                Demander une suppression de mes données
            </a>

            <a class="profil-lien" href="javascript: void 0"
               v-if="this.user.operator && this.user.operator.id === 5"
               @click.prevent="askDeleteDonnee">
                DEBUG : Supprimer les données
            </a>
        </div>

    </main-layout>
</template>

<style scoped>
.profil-lien {
    display: block;
    margin-top: 20px;
    width: 100%;
    text-align: center;
}

.fixed-bottom-btn {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: #f1f1f1;
    padding: 15px;
    color: #ff0000;
    font-size: 13px;
}
</style>

<script>

    import SignatureModal from '../common/SignatureModal.vue'

    import Security from '../../js/core/Security.js'
    import User from '../../js/models/User'
    import Api from '../../js/core/Api'

    import Cleave from 'vue-cleave'

    require('cleave.js/dist/addons/cleave-phone.fr');

    import loadImage from 'blueimp-load-image'

    export default {
        data() {
            return {
                user: {},
                showModal: false,
                isDemo: false,
                showFormUser: false,
                telOpt: {
                    phone: true,
                    phoneRegionCode: 'fr'
                }
            }
        },
        mounted: function () {
            this.fetchUserData()
        },
        computed: {
            photoProfil() {
                if (this.user.photo64) {
                    return this.user.photo64
                } else {
                    return '../../img/user-default.png'
                }
            }
        },
        methods: {
            async askSendData(){
                let data = await this.getData();
                let json = data && data.text ? JSON.parse(data.text) : null;
                let isSync = !!(json && json.offlineActions && json.offlineActions.length);
                let api = await Api.init();
                const erreurEnvoi = "Une erreur s'est produite lors de l'envoi des données. Vérifiez votre connexion puis réessayez.";

                swal({
                    'title': 'Envoi des données au support',
                    'html': "Assurez vous d'avoir une bonne connexion à internet.<br><br>"
                        + "Après l'envoi, les données locales non synchronisées seront réinitialisées sur cet appareil.",
                    'type': 'warning',
                    'confirmButtonText': 'Envoyer',
                    'showCancelButton': true,
                    'cancelButtonText': 'Annuler',
                    'showLoaderOnConfirm': true,
                    'preConfirm': () => {

                        return new Promise((resolve, reject) => {
                            if (false === isSync)  {
                                resolve(true);
                                return;
                            }

                            api
                                .post('/mail/report', data)
                                .then(res => {
                                    if (res.status === 200) {
                                        resolve(res)
                                    } else {
                                        reject(erreurEnvoi)
                                    }
                                })
                                .catch(() => reject(erreurEnvoi))
                        })
                    }
                }).then(() => {
                    const reinitialiser = () => {
                        localforage.setItem('offlineActions', JSON.stringify([])).then(() => this.$router.push('init'));
                    };
                    swal('Données envoyées', "Vos données ont bien été envoyées au support", 'success').then(reinitialiser, reinitialiser);
                }, () => {});

            },

            async askDeleteData() {
                let api = await Api.init();
                let obj = {};

                let profil = await localforage.getItem('profil');

                if (profil) {
                    obj['email'] = localStorage.getItem('email');
                    obj['user'] = JSON.parse(profil);
                }

                let data = {
                    text: "L'utiliasteur demande la suppression de ses données personnelles " + JSON.stringify(obj)
                };

                swal({
                    title: 'Suppression des données personnelles',
                    text: "Voulez-vous vraiment faire une demande de suppression de vos données personnelles ?",
                    type: 'warning',
                    confirmButtonText: 'Demander la suppression',
                    cancelButtonText: 'Annuler',
                    showCancelButton: true,
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return new Promise((resolve, reject) => {

                            api.post('/mail/report', data)
                                .then(res => {
                                    if (res.status === 200) {
                                        resolve(res);
                                    } else {
                                        reject(res);
                                    }
                                })
                                .catch(err => reject(err));
                        });
                    }
                })
                .then(() => {
                    swal('Demande envoyée', "Votre demande a bien été envoyée. La suppression de vos données sera effectuée dans les plus brefs délais.", 'success')
                        .then(() => {
                            localforage.clear().then(() => this.$router.push('init'));
                        });
                })
                .catch(() => {
                    swal('Erreur', "Demande non envoyée. Veuillez contacter le support.", 'warning');
                });
            },

            async askDeleteDonnee(){

                swal({
                    'title': 'DEBUG',
                    'text': "Suppression des données locale",
                    'type': 'warning',
                    'confirmButtonText': 'Ok',
                    'showLoaderOnConfirm': true
                }).then(() => {
                    swal('Données envoyées', "Vos données ont bien été supprimées", 'success').then(() => {
                        localforage.setItem('offlineActions', JSON.stringify([])).then(() => this.$router.push('init'));
                    });
                }).catch(() => {});

            },

            async getData() {

                let obj = {};
                let keys = await localforage.keys();

                const unauthorized = [
                    'api-token',
                    'lastConnexion',
                    'profil',
                    'OTAGS',
                    'listTypesOutil',
                    'listTypesOperation',
                    'listFournisseurs',
                    'listNomBout',
                    'listFluides',
                    'listHistory'
                ];

                for (let key of keys) {
                    if (unauthorized.indexOf(key) === -1) {
                        let res = await localforage.getItem(key);
                        obj[key] = JSON.parse(res);
                    }
                }

                if(localStorage.getItem('email')){
                    obj['email'] = localStorage.getItem('email');
                }


                return {text: JSON.stringify(obj)};

            },
            logout() {

                let router = this.$router;
                let security = new Security;

                security.logout(function (res) {
                    if (res === 'ok') {
                        router.push('login')
                    }
                })

            },
            fetchUserData() {
                User.getUserData(data => {
                    this.user = data;
                    this.isDemo = data.operator.demo;
                    if (data.phone) {
                        this.$refs.telephone.cleave.element.value = data.phone
                    }
                })
            },
            triggerPhoto() {
                this.$refs.photoInput.click()
            },
            updatePhoto(e) {
                let vueInstance = this;
                let usr = new User;
                loadImage(
                    e.target.files[0],
                    function (img) {
                        if (img instanceof Event) {
                            swal('Erreur', 'Impossible de charger cette image, vérifiez le format du fichier.', 'error');
                            return;
                        }

                        let photo = img.toDataURL();
                        vueInstance.user.photo64 = photo;
                        vueInstance.photoProfil = photo;
                        usr.updateUser(vueInstance.user)

                    },
                    {
                        maxWidth: 600,
                        maxHeight: 600,
                        orientation: true,
                        canvas: true
                    } // Options
                );
            },
            updateSignature(data) {
                this.user.signature64 = data;
                let usr = new User;
                let vueInstance = this;
                usr.updateUser(vueInstance.user)
            },
            saveInfos() {
                let usr = new User;
                let vueInstance = this;
                usr.updateUser(vueInstance.user);
                this.showFormUser = false;
            }
        },
        components: {
            SignatureModal,
            Cleave
        },
    }

</script>

<style>
    .profil .head {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
        -ms-flex-direction: row;
        flex-direction: row;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: start;
        -ms-flex-pack: start;
        justify-content: flex-start;
        margin-bottom: 20px;
        margin-top: 20px;
    }

    .profil .head .img-profil {
        border-radius: 50%;
        border: 2px solid #ccc;
        height: 100px;
        width: 100px;
        background-size: cover;
        background-position: center;
        -webkit-box-flex: 0;
        flex-grow: 0;
        margin-right: 20px;
    }

    .profil .head h2 {
        text-transform: uppercase;
        font-size: 1.8rem;
    }

    .profil .head h3 {
        color: #999;
        font-size: 1.5rem;
    }

    .profil .photo-sign {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
        -ms-flex-direction: row;
        flex-direction: row;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: start;
        -ms-flex-pack: start;
        justify-content: flex-start;
        margin-bottom: 25px;
    }

    .profil .photo-sign a {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        width: 50%;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
        -ms-flex-direction: row;
        flex-direction: row;
        -webkit-box-pack: start;
        -ms-flex-pack: start;
        justify-content: flex-start;
        padding: 0 10px;
    }

    .profil .photo-sign a i {
        margin-right: 5px;
        font-size: 3rem;
        position: static;
    }

    .profil .photo-sign a:first-child {
        margin-right: 10px;
    }

    .profil .infos-user {
        position: relative;
        background-color: #eee;
        padding: 10px;
        margin-bottom: 15px;
    }

    .profil .infos-user ul {
        padding-right: 60px;
    }

    .profil .infos-user ul li {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
        -ms-flex-direction: row;
        flex-direction: row;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: start;
        -ms-flex-pack: start;
        justify-content: flex-start;
        text-transform: uppercase;
        color: #999;
        height: 40px;
    }

    .profil .infos-user ul li i {
        font-size: 2rem;
    }

    .profil .infos-user ul li strong {
        color: #333;
        padding-left: 10px;
        text-transform: none;
    }

    .profil .infos-user a {
        position: absolute;
        right: 10px;
        top: 10px;
        width: 50px;
        height: 40px;
        text-align: center;
        padding-left: 0;
    }

    .profil .infos-user a i {
        position: static;
        top: auto;
        left: auto;
        width: 100%;
    }

    .profil .certificats {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
    }

    .profil .certificats h3 {
        text-align: center;
        text-transform: uppercase;
        color: #999;
        margin-bottom: 15px;
    }

    .profil .certificats p {
        display: -webkit-inline-box;
        display: -ms-inline-flexbox;
        display: inline-flex;
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
        -ms-flex-direction: row;
        flex-direction: row;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        text-align: center;
        height: 40px;
        padding: 0 10px;
        border-radius: 5px;
        color: #393c51;
        border: 1px solid rgba(57, 60, 81, 0.5);
    }

    .profil .certificats p i {
        font-size: 2rem;
    }

    .profil .certificats p strong {
        padding-left: 5px;
        text-transform: uppercase;
    }

    .modal-infos {
        position: fixed;
        height: 100%;
        width: 100%;
        top: 0;
        left: 0;
        background-color: rgba(55, 55, 54, 0.9);
        z-index: 99;
    }

    .modal-infos > div {
        position: absolute;
        top: 50%;
        left: 0;
        right: 0;
        margin: auto;
        -webkit-transform: translateY(-50%);
        transform: translateY(-50%);
        background-color: white;
        width: calc(100% - 20px);
        max-width: 350px;
        min-height: 300px;
        display: block;
        padding-top: 35px;
        padding-bottom: 20px;
        text-align: center;
        border-radius: 5px;
    }

    .modal-infos > div p.warning-info {
        text-transform: uppercase;
        color: #c31616;
    }

    .modal-infos > div h1 {
        margin-bottom: 25px;
    }

    .modal-infos > div form {
        width: 85%;
        margin: auto;
    }

    .modal-infos > div a {
        background-color: #5698d2;
        color: #fff;
        text-transform: uppercase;
        font-size: 1.6rem;
        border-radius: 5px;
        text-align: center;
        display: block;
        line-height: 50px;
        margin-top: 10px;
    }

    .modal-infos > div a {
        margin-left: auto;
        margin-right: auto;
        width: 140px;
    }
</style>



// WEBPACK FOOTER //
// Profil.vue?33999732